import createIcon from '../../createIcon';

/**
 * @component @name CropFree
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA1VjlINVY1SDlWM0g1QzMuOSAzIDMgMy45IDMgNVpNNSAxNUgzVjE5QzMgMjAuMSAzLjkgMjEgNSAyMUg5VjE5SDVWMTVaTTE5IDE5SDE1VjIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVYxNUgxOVYxOVpNMTkgM0gxNVY1SDE5VjlIMjFWNUMyMSAzLjkgMjAuMSAzIDE5IDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CropFree = createIcon('CropFree', [
  [
    'path',
    {
      d: 'M3 5V9H5V5H9V3H5C3.9 3 3 3.9 3 5ZM5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15ZM19 19H15V21H19C20.1 21 21 20.1 21 19V15H19V19ZM19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3Z',
      key: 'zvu0o8',
    },
  ],
]);

export default CropFree;
